import get from 'lodash/get';
import APIUtils from '@spothero/utils/api';
import SentryUtils from '@spothero/utils/sentry';

const include =
    'default_image,has_upcoming_events,google_places,deep_links,serp,parent_url,meta_title,monthly_meta_title,meta_description,monthly_meta_description,destination,monthly_description,monthly_relative_url,monthly_short_description,desktop_zoom_level,mobile_zoom_level,monthly_desktop_zoom_level,monthly_mobile_zoom_level,default_map_zoom_level,airport,hide_event_modal';

const AirportAPI = {
    getAirports() {
        return APIUtils.get('/airports/')
            .then(response => {
                try {
                    return response.data.data.results;
                } catch (error) {
                    return Promise.reject(
                        new Error('Response shape unexpected.')
                    );
                }
            })
            .catch(error => {
                const errorMessage =
                    error &&
                    (error.message ||
                        error.statusText ||
                        get(error, 'response.data', ''));

                SentryUtils.addData({
                    caughtError: error,
                });
                SentryUtils.sendMessage({
                    message: errorMessage,
                    level: 'error',
                });

                return Promise.reject(new Error(error));
            });
    },

    getByCode(code) {
        return APIUtils.get(`airports/${code}/`, {include});
    },
};

export default AirportAPI;
